import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Grid,
  Tab,
  Stack,
  Slide,
  Tabs,
  Dialog,
  TextField,
  DialogTitle,
  ListItemText,
  MenuItem,
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  DialogContent,
} from "@mui/material";
import useTabs from "../../../shared/hooks/useTabs";
import { capitalCase } from "change-case";
import Page from "../../../shared/components/Page";
import Iconify from "src/shared/components/Iconify";
import SendMoney from "../components/SendMoney";
import TransactionTable from "../components/TransactionsTable";
import SaccoBulkPayment from "../components/SaccoBulkPayment";
import { toast } from "react-toastify";
import useLocalStorage from "src/shared/hooks/useLocalStorage";
import AuthService from "../../../core/access-control/AuthService";
import { FormProvider, RHFTextField } from "../../../shared/components/hook-form";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import call from "src/core/services/http";
import Title from "src/shared/Text/Title";
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { fDateDMY } from "src/shared/utils/formatTime";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import MuiPhoneNumber from 'material-ui-phone-number';
import TransactionConstants from '../../transactions/store/TransactionConstants';
import UserConstants from 'src/packages/users/store/UserConstants';
import { filter } from 'lodash';
import BulkView from "./BulkView";
import PaymentHistory from "../components/PaymentHistory";


export default function Escrow() {
  const [open, setOpen] = useState(false);
  const { currentTab, onChangeTab } = useTabs('KTDA');
  const [shop] = useLocalStorage('shop-details');
  const [start_date, set_start_date] = useState(new Date());
  const dispatch = useDispatch();
  const [selectedPaymentOption, setSelectedPaymentOption] = useState('');
  const [showInputField, setShowInputField] = useState(false);
  const { countryCodes, countries } = useSelector(state => state.countries);


  const TABS = [
    {
      value: 'KTDA',
      icon: <Iconify icon={"game-icons:three-leaves"} width={20} height={20} />,
      component: <BulkView />,
    },
    {
      value: 'Payment Statistics',
      icon: <Iconify icon={"tdesign:money"} width={20} height={20} />,
      component: <PaymentHistory />,
    },

    // {
    //   value: ' School Fees',
    //   icon: <Iconify icon={"tdesign:money"} width={20} height={20} />,
    //   component: <SendMoney />,
    // },
  ];


  return (
    <Page title="Bulk payment services">
      <Box sx={{ m: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: "space-between", mb: 2 }} >
          <Title text="" sx={{ color: 'black' }} />
        </Box>
      </Box>
      <Grid item xs={12} md={12}>
        <TabsWrapperStyle>
          <Tabs
            TabIndicatorProps={{
              style: {
                //   display: 'none',
                paddingTop: 5,
                marginBottom: 15
              }
            }}
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
            value={currentTab}
            onChange={onChangeTab}

          >
            {TABS.map((tab) => (
              <Tab iconPosition="start" disableRipple key={tab.value} label={capitalCase(tab.value)} icon={tab.icon} value={tab.value} />
            ))}
          </Tabs>
        </TabsWrapperStyle>
        <Box sx={{ mb: 5 }} />
        {TABS.map((tab) => {
          const isMatched = tab.value === currentTab;
          return isMatched && <Box key={tab.value}>{tab.component}</Box>;
        })}
      </Grid>


    </Page>
  );
}


const TabsWrapperStyle = styled('div')(({ theme }) => ({
  zIndex: 9,
  bottom: 0,
  width: '100%',
  display: 'flex',
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'center',
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    paddingRight: theme.spacing(3),
  },
}));
